import { FC } from "react";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import { ReactComponent as LockIcon } from "assets/LockSimple.svg";
import styles from "./ProductList.module.scss";

interface Props {
  products?: {
    id: number;
    quantity: number;
    name: string;
    sku: string;
    unit_price: number;
  }[];
  onRemove: (productId: number) => void;
  onEditQuantity: (productId: number, newQuantity: number) => void;
  disabled?: boolean
}

const ProductList: FC<Props> = ({
  products, onRemove, onEditQuantity, disabled
}) => {
  return (
    <ul className={styles["list"]}>
      {products?.map((p, index) => (
        <li className={styles["list-item"]} key={index}>
          <div className={styles["list-item__index"]}>
            {index + 1}.
          </div>
          <div className={`${styles["list-item__col"]} ${styles["list-item__col--stack"]}`}>
            <div className={styles["list-item__name"]}>{p?.name?.slice(0, 20)}</div>
            <div className={styles["list-item__sku"]}>{p?.sku}</div>
          </div>
          <div className={`${styles["list-item__col"]} ${styles["list-item__col--stack-end"]}`}>
            <input
              disabled={disabled}
              className={styles["list-item__unit-input"]}
              value={p.quantity}
              onChange={(e) => onEditQuantity(p.id, parseInt(e.target.value))}
              type="number" />
            <div
              className={styles["list-item__unit-label"]}
            >Units</div>
          </div>
          {disabled ? (
            <LockIcon style={{marginTop: 7}}/>
          ) : (
            <CloseIcon
              onClick={() => onRemove(p.id)}
              className={styles["list-item__remove-btn"]} />
          )}
        </li>
      ))}
    </ul>
  )
};

export default ProductList;